import React, { useState } from 'react';
import { FiChevronLeft, FiSearch } from 'react-icons/fi';
import { IoMdPerson } from 'react-icons/io';
import { FaStethoscope } from 'react-icons/fa';
import './Sidebar.css';
import { useLanguage } from '../../context/LanguageContext';

const Sidebar = ({
  cases,
  selectedCase,
  onSelectCase,
  onClose,
  isOpen,
  completedSubmissions = {}
}) => {
  const { t } = useLanguage();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredCases = cases.filter(caseItem =>
    String(caseItem.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(caseItem.chiefComplaint || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`} inert={!isOpen} aria-hidden={!isOpen}>
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-icon"><FaStethoscope size={24} /></div>
          <div className="logo-text">
            <h2>MedTrain AI</h2>
            <p>{t('clinicalSimulator')}</p>
          </div>
        </div>
        <button type="button" className="close-btn" onClick={onClose} aria-label={t('closeSidebar')}>
          <FiChevronLeft size={20} />
        </button>
      </div>

      <div className="sidebar-search">
        <div className="search-box">
          <FiSearch size={18} />
          <input
            type="text"
            aria-label={t('searchCases')}
            placeholder={t('searchCases')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="sidebar-section">
        <div className="section-header">
          <h3>{t('activeCases')}</h3>
          <span className="badge">{filteredCases.length}</span>
        </div>
        <div className="cases-list">
          {filteredCases.map((caseItem) => (
            <button
              type="button"
              key={caseItem.id}
              className={`case-card ${selectedCase?.id === caseItem.id ? 'selected' : ''}`}
              aria-pressed={selectedCase?.id === caseItem.id}
              onClick={() => onSelectCase(caseItem)}
            >
              <div className="case-avatar">
                <IoMdPerson size={20} />
              </div>
              <div className="case-info">
                <h4>{caseItem.name}</h4>
                <div className="case-meta">
                  <span className="case-age">{caseItem.age}y</span>
                  {completedSubmissions[caseItem.id]
                    ? <span className="case-status case-done">{t('completed')}</span>
                    : <span className="case-status">{t('active')}</span>
                  }
                </div>
                <p className="case-preview">{String(caseItem.chiefComplaint || '').substring(0, 40)}...</p>
              </div>
              <div className="case-action">
                <FaStethoscope size={16} />
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
